<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
<div class="mr-auto">
  <el-button type="default" size="mini" @click="getList('')" :class="this.btn_select =='' ?'bg-primary text-white':''">전체경주</el-button>
  <el-button type="default" size="mini" @click="getList('1')" :class="this.btn_select =='1' ?'bg-primary text-white':''">한국경마</el-button>
  <el-button type="default" size="mini" @click="getList('4')" :class="this.btn_select =='4' ?'bg-primary text-white':''">일본경마</el-button>
  <el-button type="default" size="mini" @click="getList('5')" :class="this.btn_select =='5' ?'bg-primary text-white':''">일본경륜</el-button>
  <el-button type="default" size="mini" @click="getList('6')" :class="this.btn_select =='6' ?'bg-primary text-white':''">일본경정</el-button>
  <el-button type="default" size="mini" @click="getList('8')":class="this.btn_select =='8' ?'bg-primary text-white':''">중앙경마</el-button>
</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
        class="mt-2 el-table-new"

       empty-text="데이타가 없습니다">
        <el-table-column
      align="center" label="리턴" >
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" plain @click="todayRound(scope)" :disabled="scope.row.btn1">리턴</el-button>
        
        
      </template>
      </el-table-column>

      <el-table-column
        
        label="구분" prop="" align="center" >
         <template slot-scope="scope">
         {{scope.row.type}}
         </template>   
        
      </el-table-column> 


      <el-table-column
        
        label="장소" prop="race_jang" align="center" >
         <template slot-scope="scope">
            {{jsarr[scope.row.race_jang]}}- {{scope.row.race_num}}
         </template>   
        
      </el-table-column> 

        

       
   
       <el-table-column
        
        label="시간" prop="race_time" align="center" >
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_time" class="h20 w-75">
          </el-input>
          </template>
      </el-table-column> 
     
      <el-table-column
        
        label="인원" prop="race_su" align="center" >
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_su" class="h20 w-75"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="1착" prop="numberSum" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_1" class="h20 bgOne"></el-input>
              <el-input type="text" v-model="scope.row.race_1_1" class="h20 bgOne "></el-input>
          </template>
      </el-table-column> 
        <el-table-column
        
        label="2착" prop="powerball" align="center"  width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_2" class="h20 bgTwo"></el-input>
              <el-input type="text" v-model="scope.row.race_2_2" class="h20 bgTwo"></el-input>
          </template>
      </el-table-column> 
        <el-table-column
        
        label="3착" prop="powerballOddEven" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_3" class="h20 bgThree"></el-input>
               <el-input type="text" v-model="scope.row.race_3_3" class="h20 bgThree"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="복승" prop="numberOddEven" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_3_b1" class="h20 bgThree"></el-input>
              <el-input type="text" v-model="scope.row.race_3_b2" class="h20 bgThree"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="쌍승" prop="powerballUnderOver" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_4_b1" class="h20 bgFive"></el-input>
               <el-input type="text" v-model="scope.row.race_4_b2" class="h20 bgFive"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="복연승" prop="numberUnderOver"  align="center" width="50">
        <template slot-scope="scope" v-if="scope.row.race_jang<=3">
              <el-input type="text" v-model="scope.row.race_5_b1" class="h20 bgOne"></el-input>
              <el-input type="text" v-model="scope.row.race_5_b2" class="h20 bgOne"></el-input>
              <el-input type="text" v-model="scope.row.race_5_b3" class="h20 bgOne"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="삼복승" prop="numberPeriod" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_6_b1" class="h20 bgTwo"></el-input>
              <el-input type="text" v-model="scope.row.race_6_b2" class="h20 bgTwo"></el-input>
          </template>
      </el-table-column>

      <el-table-column
        
        label="삼쌍승" prop="numberPeriod" align="center" width="50">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.race_7_b1" class="h20 bgEight"></el-input>
               <el-input type="text" v-model="scope.row.race_7_b2" class="h20 bgEight"></el-input>
          </template>
      </el-table-column>


       <el-table-column
      align="center"  label="수정">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" @click="edit(scope)" :disabled="scope.row.btn3">등록</el-button>
        
        
      </template>
      </el-table-column>

      <!--  <el-table-column
        
        label="내역" prop="gubun" align="center"  width="150">
         <template slot-scope="scope">
        
         <div v-for="(item,index) in scope.row.gubun" :key="index">
         {{formatMoney(item)}}
         </div>
        
        
      </template>
      </el-table-column> -->

       <el-table-column
        
        label="마감" prop="cc" align="center">
          <template slot-scope="scope"><span class="text-danger">{{scope.row.cc}}</span></template>
      </el-table-column>
       <el-table-column
        
        label="배팅금" prop="total" align="center">
          <template slot-scope="scope"><el-button type="text" @click="getBuyGrd(scope)">{{ formatMoney(scope.row.total)}}</el-button></template>
      </el-table-column>
     

      <el-table-column
        
        label="적중금" prop="total_e" align="center" >
         <template slot-scope="scope">{{ formatMoney(scope.row.total_e)}}</template>
        
      </el-table-column>
      </el-table>
      <div style="clear:both"></div>



       <el-table
      :data="raceData"
      
       style="width:800px"
       border class="mt-2"
       empty-text="데이타가 없습니다" @selection-change="handleSelectionChange">

        <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
    
   
         <el-table-column
        label="ID" prop="idx" align="center" width="100">
         
      </el-table-column> 

      <el-table-column
        label="IP" prop="ip" align="center" width="200">
        
      </el-table-column> 
      <el-table-column
        label="DATE" prop="add_date" align="center">
        
      </el-table-column> 
      <el-table-column
        label="url" prop="contents" align="center">
        <template slot-scope="scope">
           <el-input
                          type="textarea"
                          :rows="2"
                          v-model="scope.row.contents">
                        </el-input>
        </template>
        
      </el-table-column>
    </el-table>
    <div class="mt-2">
       <el-button type="danger"size="mini" @click="deleteAll">Delate</el-button>
    </div>



     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				   <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[50, 70, 100,]"
            :page-size="size"
            layout="sizes,prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
				</el-footer>	
          <el-dialog
          :title="race_title"
          :close-on-click-modal ="false"
          :visible.sync="getBuyGraModel" :width="racew">

         <table id="buy_rgd" class="table table-bordered table-striped">
           <tr>
            <th>NO</th>
             <th v-for="i in race_su">{{i}}</th>
            
           </tr>


           <tr v-for="i in race_su">
            <td class="bgtd">{{i}}</td>
            
            <td v-for="(x,index) in race_su">
             <template v-if="x==i">{{x}}</template>
             <template v-else=""><span class="text-primary" v-if='bdlist[i+"-"+x]'>{{formatMoney(bdlist[i+"-"+x])}}</span></template> 
            </td>
            
           
           </tr>
            
           

         </table>

          <span slot="footer" class="dialog-footer">
             <el-button @click="getBuyGraModel = false">취소</el-button>
            <el-button type="primary">확인</el-button>
          </span>
        
       
       
        </el-dialog>
        
				
</div>
 </template>

 <script>
 
 
    export default {
    
    	data(){
    		return{
          total:0,
          size:0,
          currentPage:1,

          racew:'800px',
          raceData:[],
           multipleSelection:[],
          getBuyGraModel:false,
          jsarr:new Array("", "부산", "과천", "제주", "광명", "창원", "미사리", "부산(경륜)", "나고야", "미즈사와", "사가", "삿포로", "소노다", "아라오", "오비히로", "우라와", "카나자와", "코치", "후쿠야마", "후나바시", "카와사키", "아사히카와", "카사마츠", "오오이", "모리오카", "몬베츠", "히메지", "이와키", "벳푸", "가와사키", "마에바시", "오미야", "무코마치", "다카마쓰", "게이오카쿠", "이토", "도야마","키시와다", "마츠야마", "오구라","히라츠카","사세보","마츠도","오가키","나고야","마쓰사카","구루메","도요하시","와카야마","히로시마","오다와라","시즈오카","기후","나라","다치카와","욧카이치","세이부엔","후쿠이","우츠노미야","다케오", "에도가와", "스미노에", "헤이와지마", "하마나코", "아마가사키", "나루토", "다마가와", "마루가메", "토다", "기류","가마고오리","","","","","","","","","","한신", "나카야마", "쥬쿄","오구라","도쿄","니가타","삿포로","후쿠시마","하코다테"),
          domain:window.sessionStorage.getItem('domain'),
    		disabled:false,
        race_su:0,
        bdlist:[],
        race_title:'',
        btn_select:'',
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          valuenum:'1',    		
		    		 loading: false,
		    		 tableData: [],
			      

    			}
    			
    			
    		},
    		created() {
    			

    			this.getList('');

          const timer = window.setInterval(()=>{
             this.djs()
            }, 1000)
            
            this.$once('hook:beforeDestroy', function () {
               window.clearInterval(timer)
            })
    			
			
		},
   
    	methods:{
        handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
         deleteAll(){
        this.$confirm('삭제하시겠습니까?복구불가!', '알림', {
          confirmButtonText: '삭제',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.id);
            newids.push(item.idx);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                      data:{idx:newids},
                      url:this.domain+'/admin/log_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      }, 
  handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
        formatSeconds(value){

          let fushu='';

          if(value<0)
          {
//return "마감";
value=value*-1;
              fushu='-';
          }
              var theTime = parseInt(value);// 需要转换的时间秒 
 var theTime1 = 0;// 分 
 var theTime2 = 0;// 小时 
 var theTime3 = 0;// 天
 if(theTime > 60) { 
  theTime1 = parseInt(theTime/60); 
  theTime = parseInt(theTime%60); 
  if(theTime1 > 60) { 
   theTime2 = parseInt(theTime1/60); 
   theTime1 = parseInt(theTime1%60); 
   if(theTime2 > 24){
    //大于24小时
    theTime3 = parseInt(theTime2/24);
    theTime2 = parseInt(theTime2%24);
   }
  } 
 } 
 var result = '';
 if(theTime > 0){
  result = ""+parseInt(theTime)+"초";
 }
 if(theTime1 > 0) { 
  result = ""+parseInt(theTime1)+"분"+result; 
 } 
 if(theTime2 > 0) { 
  result = ""+parseInt(theTime2)+"시"+result; 
 } 
 if(theTime3 > 0) { 
  result = ""+parseInt(theTime3)+"일"+result; 
 }
 return fushu+''+result; 
        },
          djs(){
            var timestamp=new Date().getTime()
            let ctime=parseInt(timestamp/1000)

            //console.log('ctime',ctime)
            let newdjs=[];
            this.tableData.forEach((item,index)=>{

              
               newdjs[index]=item
               newdjs[index].cc=this.formatSeconds(item.djs-ctime);
               //console.log('00',item);
           });

            //this.tableData=newdjs

            //console.log('new',newdjs);



            
          },
          edit(e){
              this.$confirm('등록하시겠습니까?', '알림', {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
              type: 'warning'
            }).then(() => {
            
                    let token=window.sessionStorage.getItem('user');
            e.row.btn3 = true
            this.$axios({
                      method:'post',
                      url:this.domain+'/admin/race_result_up',
                      data:{
                          race_1:e.row.race_1,
                          race_1_1:e.row.race_1_1,
                          race_2:e.row.race_2,
                          race_2_2:e.row.race_2_2,
                          race_3:e.row.race_3,
                          race_3_3:e.row.race_3_3,
                          race_3_b1:e.row.race_3_b1,
                          race_3_b2:e.row.race_3_b2,
                          race_4_b1:e.row.race_4_b1,
                          race_4_b2:e.row.race_4_b2,
                          race_5_b1:e.row.race_5_b1,
                          race_5_b2:e.row.race_5_b2,
                          race_5_b3:e.row.race_5_b3,
                          race_6_b1:e.row.race_6_b1,
                          race_6_b2:e.row.race_6_b2,
                          race_7_b1:e.row.race_7_b1,
                          race_7_b2:e.row.race_7_b2,
                          race_idx:e.row.race_idx,
                        },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                     
                  }).then((response) =>{ 

                   e.row.btn3 = false

                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })

                      this.getList(this.btn_select)
                    }else{

                      this.$message.error(response.data.msg)
                    }
                    
                   
                   
                  }).catch((error) =>{
                      e.row.btn3 = false
                      console.log(error)
                  })

            }).catch(() => {
            this.$message({
              type: 'info',
              message: '취소됨'
            });          
        });
          
           
         
            
         
        },
    			cloud(e){
          let token=window.sessionStorage.getItem('user');

          let url="";
          let jang=e.row.race_jang;
          let num=e.row.race_num;
          if(jang>=8 && jang<=26)
          {
             url="auto_jp_json.php";
          }
          else if(jang>26 && jang <60)
          {
             url="auto_jp_cycel_json.php";
          }
          else if(jang>=60 && jang<80)
          {
             url="auto_jp_boat_json.php";
          }
          else if(jang>=80 && jang<100)
          {
             url="auto_jra_json.php";
          }
          else if(jang<=3)
          {
             url="autonew_json.php";
          }

           e.row.btn2 = true

           this.$axios({
                      method:'get',
                      url:this.domain+"/admin/get_race_json?url="+url+"&rand="+Math.random()+"&jang="+jang+"&num="+num,
                      
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    e.row.btn2 = false

                  //console.log('response',response);

                   if(response.data.code==200){
                  //console.log(response.data);
                   let dd=response.data.data;

                      e.row.race_1=dd.race_1
                      e.row.race_1_1=dd.race_1_1
                      e.row.race_2=dd.race_2
                      e.row.race_2_2=dd.race_2_2
                      e.row.race_3=dd.race_3
                      e.row.race_3_3=dd.race_3_3
                      e.row.race_3_b1=dd.race_3_b1
                      e.row.race_3_b2=dd.race_3_b2
                      e.row.race_4_b1=dd.race_4_b1
                      e.row.race_4_b2=dd.race_4_b2
                      e.row.race_5_b1=dd.race_5_b1
                      e.row.race_5_b3=dd.race_5_b3
                      e.row.race_5_b2=dd.race_5_b2
                      e.row.race_6_b1=dd.race_6_b1
                      e.row.race_6_b2=dd.race_6_b2
                      e.row.race_7_b1=dd.race_7_b1
                      e.row.race_7_b2=dd.race_7_b2
                      this.$message.success('success')

                    }else{

                        this.$message.error(response.data.msg)
                    }
                  
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
        },
           
    		
			     
			    
       todayRound(e){
         this.$confirm('리턴하시겠습니까', '알림', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

            e.row.btn1 = true


           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/race_res_cancel?race_idx='+e.row.race_idx,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },  
                     
                  }).then((response) =>{ 
                     e.row.btn1 = false
                  
                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  

                       this.getList(this.btn_select) 
                    }else{
                      this.$message.error(response.data.msg)
                    }
                   // this.disabled = false
    
                    }).catch((error) =>{
                       e.row.btn1 = false
                        console.log(error)       //请求失败返回的数据
                    })
        
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });
       
     
         
        },
    		getList(type){

    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');

           this.btn_select=type;
    				//console.log(token);
    			 let urls=this.domain+'/admin/race_result?type='+type+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                  console.log('tableData=',response.data.racelogs)
                     let data = response.data.data
                     this.tableData =data.data
                     this.raceData =response.data.racelogs

                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
       
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
              
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
        
    	getBuyGrd(e){
        this.getBuyGraModel = true
        let token=window.sessionStorage.getItem('user');
        this.race_title=this.jsarr[e.row.race_jang]+'-'+e.row.race_num
        this.$axios({
                        method:'get',
                        url:this.domain+'/admin/get_buy_grd?race_jang='+e.row.race_jang+'&race_num='+e.row.race_num,
                       
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },  
                  }).then((response) =>{ 
                      console.log('tabledata',response.data.data) 
                      this.race_su=parseInt(response.data.race_su)
                      this.bdlist=response.data.data

                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            

      },
    
    		
    	}
  }
</script>

 <style scoped>
/deep/ #buy_rgd th{
  background: #cbf8fd;
  text-align: center;
}
/deep/ #buy_rgd td{
  text-align: center;
}
/deep/ #buy_rgd td.bgtd{
  background: #fffcaf;
  width: 100px;
  text-align: center;
}
/deep/.h20 .el-input__inner{
  height:20px;
  line-height:20px;
  padding:0;
  text-align: center;
  border-radius: 0;
}
/deep/.bgOne .el-input__inner{
  background:#FFEDED ;
  
}
/deep/.bgTwo .el-input__inner{
  background:#EDFFF7 ;
  
}
/deep/.bgThree .el-input__inner{
  background:#FFFEED ;
  
}

/deep/.bgFive .el-input__inner{
  background:#EAF4F7 ;
  
}


/deep/.bgEight .el-input__inner{
  background:#FFF8D7 ;
  
}
/deep/ .el-table-new td.el-table__cell{
    border-bottom: 1px solid #ddd;

}

</style>


// WEBPACK FOOTER //
// src/views/race/list.vue